import { PostCard } from 'components/post-card';
import { PostCardDataFragment } from 'lib/graphql-generated';
import Link from 'next/link';

interface Props {
  lists: PostCardDataFragment[];
}
export const ListReccomendations = ({ lists }: Props) => {
  return (
    <section className='[ order-3 ] w-full p-8 bg-green-very-light lg:order-4'>
      <div className='space-y-6 w-full max-w-screen-xl mx-auto flex flex-row flex-wrap'>
        <h2 className=' uppercase tracking-wide font-header text-2xl w-full  pb-4 md:pb-8'>
          Featured in lists:
        </h2>

        <ul className='w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12'>
          {lists.map((list) => (
            <PostCard
              post={list}
              className='w-full max-w-sm mx-auto'
              key={list.id}
            />
          ))}
        </ul>
      </div>
      <hr className='mt-14 border-black border-2 max-w-screen-lg mx-auto' />
    </section>
  );
};
